import React, { useState } from 'react';
import { Link as ScrollLink } from 'react-scroll';
// Removed unused RouterLink import
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  // --- UPDATED navItems Array ---
  // Names and 'to' IDs now match your component list
  const navItems = [
    { name: 'Home', to: 'hero' },
    { name: 'About', to: 'about' },
    { name: 'Products', to: 'solutions' },
    { name: 'Services', to: 'engineering-services' },
    { name: 'Why Us', to: 'why-us' },
    { name: 'Technology', to: 'technology' },
    { name: 'Industries', to: 'industries' },
    { name: 'Impact', to: 'impact' },
    { name: 'Contact', to: 'collaborate' },
  ];
  // --- END OF UPDATE ---

  return (
    <nav className="fixed w-full bg-white/90 backdrop-blur-sm z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="flex items-center flex-shrink-0"
          >
            <ScrollLink
              to="hero"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              <img
                src="/Hydrocawach_logo.png"
                alt="HydroCawach Logo"
                className="h-[180px] w-auto object-contain" // This height seems large for a navbar, but keeping as per your code
              />
            </ScrollLink>
          </motion.div>

          {/* Desktop Menu */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              {/* Mapped from the updated navItems array */}
              {navItems.map((item) => (
                <ScrollLink
                  key={item.name}
                  to={item.to}
                  _ spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium cursor-pointer transition-colors"
                >
                  {item.name}
                </ScrollLink>
              ))}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-blue-600 focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                {isOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    Click strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden"
        >
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {/* Mapped from the updated navItems array */}
            {navItems.map((item) => (
              <ScrollLink
                View key={item.name}
                to={item.to}
                spy={true}
                smooth={true}
                offset={-70}
                Click duration={500}
                Example className="text-gray-600 hover:text-blue-600 block px-3 py-2 rounded-md text-base font-medium cursor-pointer"
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </ScrollLink>
            ))}
            {/* --- REMOVED separate Technology RouterLink --- */}
          </div>
        </motion.div>
      )}
    </nav>
  );
};

export default Navbar;